export const DG_BRAND_CONFIG = {
  displayName: 'DG embalajes',
  publicWebsiteUrl: 'https://www.envasesdecarton.com.ar',
} as const;

export const DG_STORE_CONFIG = {
  url: 'https://www.tubosdecarton.com.ar',
  actionLabel: 'Ver precios y medidas',
} as const;

export const DG_WHATSAPP_CONFIG = {
  phoneE164: '5491158796618',
  phoneDisplay: '11 5879-6618',
  messages: {
    general:
      'Hola DG embalajes, quiero enviar un PDF generado en el configurador para revisión.',
    tubeReview:
      'Hola, ya terminé mi diseño de envase. Te envío el PDF para producción.',
    stickerReview:
      'Hola, armé un PDF de sticker a medida real desde el configurador. ' +
      'Te lo envío para revisión.',
  },
} as const;

export type WhatsAppMessageKind = keyof typeof DG_WHATSAPP_CONFIG.messages;

export function buildWhatsAppUrl(
  message: string,
  phoneE164 = DG_WHATSAPP_CONFIG.phoneE164,
): string {
  if (!/^\d+$/.test(phoneE164)) {
    throw new Error('El telefono de WhatsApp debe contener solo digitos.');
  }
  if (message.trim().length === 0) {
    throw new Error('El mensaje de WhatsApp no puede estar vacio.');
  }

  return 'https://wa.me/' + phoneE164 + '?text=' + encodeURIComponent(message);
}

export function getWhatsAppUrl(kind: WhatsAppMessageKind): string {
  return buildWhatsAppUrl(DG_WHATSAPP_CONFIG.messages[kind]);
}

export const DG_COMMERCE_CONFIG = {
  brand: DG_BRAND_CONFIG,
  store: DG_STORE_CONFIG,
  whatsapp: DG_WHATSAPP_CONFIG,
} as const;
